const domain = window.location.hostname;
const button = Array.from(document.querySelectorAll("[button='login']"));
const currentPath = window.location.pathname.slice(1).replace(/\/$/, "");

if (domain === "feta.io") {
  button.forEach(function (btn, i) {
    btn.setAttribute("href", `https://feta.io/login?source=${currentPath}`);
  });
} else if (domain === "feta.sh") {
  button.forEach(function (btn, i) {
    btn.setAttribute("href", `https://feta.sh/login?source=${currentPath}`);
  });
}
